<template>
    <Card>
	    <template #content>
        <div class="flex flex-col gap-8">
	        <FormGroup :label="$t('forms.device_manufacturer.device_manufacturer_properties_form.name')" :error-text="form.errors?.name">
                <InputText
                    data-cy="device-manufacturer-company-name-input-box"
                    v-model="form.name"
                    @change="form.validate('name')"
                    :disabled="disabled"
                />
	        </FormGroup>
            <FormGroup
                :label="$t('forms.device_manufacturer.device_manufacturer_properties_form.company')"
                :error-text="form.errors?.company_ids || form.errors?.company_id"
            >
                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-3">
                        <InputSwitch
                            v-model="availableToAllCompanies"
                            :disabled="disabled"
                            data-cy="available-to-all-companies-switchbtn"
                        />
                        <span class="text-sm text-surface-500">{{ allCompaniesLabel }}</span>
                    </div>
                    <MultiSelect
                        v-if="!availableToAllCompanies"
                        v-model="form.company_ids"
                        :options="companiesStore.getCompanyOptions"
                        option-label="name"
                        option-value="id"
                        :disabled="disabled"
                        display="chip"
                        class="w-full"
                        @change="onCompanyIdsChange"
                        data-cy="company-name-multiselection-input"
                    />
                </div>
            </FormGroup>
        </div>
	    </template>

	    <template v-if="!disabled && (hasOnSaveListener || hasOnDeleteListener)" #footer>
		    <div class="flex justify-end space-x-3">
			    <Button data-cy="device-manufacturer-delete-btn"class="px-8" text severity="danger" v-if="hasOnDeleteListener && form.id" @click="$emit('on-delete', form)" :label="$t('forms.common.delete')"
			            :disabled="form.processing"/>
			    <Button data-cy="device-manufacturer-save-btn" class="px-8" v-if="hasOnSaveListener" @click="emitSave(form)" :label="$t('forms.common.save')"
			            :disabled="form.processing"/>
		    </div>
	    </template>
    </Card>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import companySelectionValidation from "@/Mixins/companySelectionValidation.js";

export default {
    name: "DeviceManufacturerPropertiesForm",
    components: {FormGroup},
    mixins: [companySelectionValidation],
    data() {
        return {
            availableToAllCompanies: true,
        };
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useCompaniesStore),
        hasOnSaveListener() {
            return !!(this.$attrs?.onOnSave);
        },
		    hasOnDeleteListener() {
			    return !!(this.$attrs?.onOnDelete);
		    },
        allCompaniesLabel() {
            return this.canSavePublicManufacturer
                ? this.$t('forms.common.all')
                : this.$t('forms.common.all_accessible_companies');
        },
        canSavePublicManufacturer() {
            return this.$auth.hasPermission('update:all-device-manufacturers');
        },
        companyRequiredMessage() {
            return this.$t('forms.device_manufacturer.device_manufacturer_properties_form.company_required');
        },
    },
    methods: {
        onCompanyIdsChange() {
            this.form.company_id = this.form.company_ids?.length === 1
                ? this.form.company_ids[0]
                : null;
            if (!this.validateCompanySelection()) {
                return;
            }
            this.form.validate('company_ids');
        },
        setInitialCompanyIds() {
            if (!Array.isArray(this.form.company_ids)) {
                this.form.company_ids = this.form.company_id ? [this.form.company_id] : [];
            }
            this.availableToAllCompanies = !this.form.company_ids.length;
            this.form.apply_to_all_companies = this.availableToAllCompanies;
        },
    },
    watch: {
        availableToAllCompanies(value) {
            this.form.apply_to_all_companies = value;
            if (value) {
                this.form.company_ids = [];
                this.form.company_id = null;
                this.clearCompanySelectionError();
                return;
            }

            this.validateCompanySelection();
        },
    },
    mounted() {
        this.setInitialCompanyIds();
        this.companiesStore.indexCompanyOptions();
    }
}
</script>

<style scoped>

</style>
